export const reportBNSF = [
  {
    field: 'transit_goal_datetime',
    title: 'Transit Goal DateTime',
  },
  {
    field: 'car_id',
    title: 'Car ID',
  },
  {
    field: 'chassis_id',
    title: 'Chassis ID',
  },
  {
    field: 'confirmed_estimated_customer_notification_datetime',
    title: 'Confirmed Estimated Customer Notification DateTime',
  },
  {
    field: 'customer_requested_datetime',
    title: 'Customer Requested DateTime',
  },
  {
    field: 'demurrage_amount',
    title: 'Demurrage Amount',
  },
  {
    field: 'demurrage_start_date',
    title: 'Demurrage Start Date',
  },
  {
    field: 'destination_rail_network_location_name',
    title: 'Destination Rail Network Location Name',
  },
  {
    field: 'equipment_initial',
    title: 'Equipment Initial',
  },
  {
    field: 'equipment_number',
    title: 'Equipment Number',
  },
  {
    field: 'estimated_shipment_availability_datetime',
    title: 'Estimated Shipment Availability DateTime',
  },
  {
    field: 'estimated_customer_notification_datetime',
    title: 'Estimated Customer Notification DateTime',
  },
  {
    field: 'final_destination_rail_network_location_name',
    title: 'Final Destination Rail Newtork',
  },
  {
    field: 'final_scheduled_event_description',
    title: 'Final Scheduled Event Description',
  },
  {
    field: 'latitude',
    title: 'Latitude',
  },
  {
    field: 'longitude',
    title: 'Longitude',
  },
  {
    field: 'last_reporting_scac',
    title: 'Last Reporting SCAC',
  },
  {
    field: 'next_scac',
    title: 'Next SCAC',
  },
  {
    field: 'next_scheduled_event_datetime',
    title: 'Next Scheduled Event DateTime',
  },
  {
    field: 'next_scheduled_event_description',
    title: 'Next Scheduled Event Description',
  },
  {
    field: 'next_scheduled_event_station',
    title: 'Next Scheduled Event Station',
  },
  {
    field: 'next_scheduled_event_state_code',
    title: 'Next Scheduled Event State Code',
  },
  {
    field: 'origin_rail_network_location_name',
    title: 'Origin Rail Network Location Name',
  },
  {
    field: 'original_train_departure_datetime',
    title: 'Original Train Departure DateTime',
  },
  {
    field: 'original_train_departure_type_code',
    title: 'Original Train Departure Type Code',
  },
  {
    field: 'shipment_exception_description',
    title: 'Shipment Exception Description',
  },
  {
    field: 'train_id',
    title: 'Train ID',
  },
  {
    field: 'trucking_company_name',
    title: 'Trucking Company Name',
  },
  {
    field: 'unit_type_code',
    title: 'Unit Type Code',
  },
  {
    field: 'waybill_number',
    title: 'Waybill Number',
  },
  {
    field: 'last_event',
    title: 'Last Event',
  },
  {
    field: 'last_event_datetime',
    title: 'Last Event DateTime',
  },
  {
    field: 'last_event_rail_network_location_name',
    title: 'Last Event Rail Network Location Name',
  },
  {
    field: 'lot_location',
    title: 'Lot Location',
  },
];
